import { buildNameColumn } from './name-column';
import { buildVriColumn } from './vri-column';
import { buildVrrColumn } from './vrr-column';
import { buildInconsistenciesColumn } from './inconsistencies-column';
import { buildServicesColumn } from './services-column';
import { buildIdColumn } from './id-column';
import { buildSpeciesColumn } from './species-column';
import { buildProductColumn } from './product-column';
import { buildLifecycleDateColumn } from './lifecycle-date-column';
import { buildBaggingDateColumn } from './bagging-date-column';
import { buildOriginMoistureColumn } from './origin-moisture-column';
import { buildOnFieldStockColumn } from './on-field-stock';
import { buildTotalExtractedWeightColumn } from './total-extracted-weight';
import { buildCountrysideColumn } from './countryside-column';
import { buildOrganizationColumn } from './organization-column';
import { buildAlertColumn } from './alert-column';
import { buildActionColumn } from './action';
import { buildInputWeightColumn } from './input-weight-column';

export const COL = {
  NAME: buildNameColumn,
  VRI: buildVriColumn,
  VRR: buildVrrColumn,
  INCONSISTENCIES: buildInconsistenciesColumn,
  SERVICES: buildServicesColumn,
  ID: buildIdColumn,
  SPECIES: buildSpeciesColumn,
  PRODUCT: buildProductColumn,
  LIFECYCLE_DATE: buildLifecycleDateColumn,
  BAGGING_DATE: buildBaggingDateColumn,
  ORIGIN_MOISTURE: buildOriginMoistureColumn,
  ON_FIELD_STOCK: buildOnFieldStockColumn,
  TOTAL_EXTRACTED_WEIGHT: buildTotalExtractedWeightColumn,
  COUNTRYSIDE: buildCountrysideColumn,
  ORGANIZATION: buildOrganizationColumn,
  ALERT: buildAlertColumn,
  INPUT_WEIGHT: buildInputWeightColumn,
  ACTION: buildActionColumn,
} as const;
